import { Box, Input, SearchIcon } from '@deckee/deck-hand';
import React, { FC, FormEvent, useEffect, useState } from 'react';
import {
  Route,
  Switch,
  useHistory,
  useLocation,
  useRouteMatch,
} from 'react-router-dom';
import { useTheme } from 'styled-components';
import { captureEvent } from '../../../services/event-capture';
import { useAppDispatch } from '../../../services/store';
import {
  fetchCourseCategories,
  setCourseSearchTerm,
} from '../../../services/store/modules/courses';
import BasicDrawerLayout from '../../layouts/BasicDrawerLayout/BasicDrawerLayout';
import HeaderBarButton from '../../layouts/components/HeaderBarButton/HeaderBarButton';
import { back } from '../../shared/vector-images';
import CourseCategoriesPage from './CourseCategoriesPage/CourseCategoriesPage';
import CourseListPage from './CourseListPage/CourseListPage';

const CoursesFeature: FC = () => {
  const { path } = useRouteMatch();
  const { pathname } = useLocation();
  const history = useHistory();
  const dispatch = useAppDispatch();
  const {
    colors: { primary },
  } = useTheme();

  const [searchTerm, setSearchTerm] = useState('');

  const isOnCourseList = pathname === '/maps/courses/list';

  useEffect(() => {
    dispatch(setCourseSearchTerm(searchTerm));
    if (searchTerm && !isOnCourseList) {
      history.push('/maps/courses/list');
    }
  }, [dispatch, history, isOnCourseList, path, pathname, searchTerm]);

  const handleBack = () => {
    captureEvent({
      type: 'courses: select back',
      payload: {},
      sendToAmplitude: true,
    });
    setSearchTerm('');
    if (isOnCourseList) {
      history.push('/maps/courses');
    } else {
      history.push('/maps/prepare');
    }
  };

  useEffect(() => {
    // This will be changed to fetch course categories in the future. For now, we show all courses
    dispatch(fetchCourseCategories());
  }, [dispatch]);

  return (
    <BasicDrawerLayout onClose={null} showHeaderBar={false} showMenuBar={false}>
      {/* Adjusting the left padding because our current back icon looked a bit off */}
      <Box p="3" pl="0" pb="0" bg="#f4f4f4" display="flex">
        <HeaderBarButton
          ariaLabel="return"
          icon={back()}
          onClick={handleBack}
          large
        />
        <Box flex="1 1 0px">
          <Input
            type="text"
            size="medium"
            aria-label="search"
            placeholder="Search for courses"
            startEnhancer={() => <SearchIcon color={primary} />}
            clearable
            value={searchTerm}
            onChange={(event: FormEvent<HTMLInputElement>) =>
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              setSearchTerm(event.target?.value || '')
            }
          />
        </Box>
      </Box>
      <Switch>
        <Route path={path} exact>
          <CourseCategoriesPage />
        </Route>

        <Route path={`${path}/list`} exact>
          <CourseListPage />
        </Route>
      </Switch>
    </BasicDrawerLayout>
  );
};

export default CoursesFeature;
